/** Bounded optical cues consume the domain's exact incident/reflected paths.
 * Charge and live beams differ in width/color without blinking; reduced motion
 * retains every gameplay cue. Original imported models own all solid artwork. */
export function createSkyPrismOptics(T, scene, own) {
  const geometry = own(new T.CylinderGeometry(1, 1, 1, 8, 1, true));
  const group = new T.Group();
  group.name = 'Prism physical optical paths';
  scene.add(group);
  const objects = [];
  for (let i = 0; i < 14; i++) {
    const material = own(
      new T.MeshBasicMaterial({
        color: '#9cdfff',
        transparent: true,
        opacity: 0.65,
        depthWrite: false,
      }),
    );
    const mesh = new T.Mesh(geometry, material);
    mesh.frustumCulled = false;
    group.add(mesh);
    objects.push(mesh);
  }
  const up = new T.Vector3(0, 1, 0),
    a = new T.Vector3(),
    b = new T.Vector3();
  let count = 0;
  function segment(from, to, radius, color, opacity) {
    if (count >= objects.length || !from || !to) return;
    a.set(from.x, from.y, from.z);
    b.set(to.x, to.y, to.z);
    const mesh = objects[count++],
      length = a.distanceTo(b);
    mesh.position.copy(a).add(b).multiplyScalar(0.5);
    mesh.quaternion.setFromUnitVectors(up, b.sub(a).normalize());
    mesh.scale.set(radius, Math.max(0.001, length), radius);
    mesh.material.color.set(color);
    mesh.material.opacity = opacity;
    mesh.visible = true;
  }
  function draw(state, visible = true) {
    count = 0;
    const systems = visible && !state.boss?.defeated ? state.boss?.prism : null;
    for (const web of systems?.web ?? []) segment(web.from, web.to, 0.055, '#a392e4', 0.58);
    for (const beam of systems?.beams ?? []) {
      segment(
        beam.from,
        beam.to,
        beam.active ? 0.22 : 0.045,
        beam.active ? '#f3dfff' : '#ffc66f',
        beam.active ? 0.92 : 0.6,
      );
      if (beam.reflected)
        segment(
          beam.reflected.from,
          beam.reflected.to,
          beam.active ? 0.18 : 0.035,
          beam.core ? '#aaffda' : '#b783ff',
          beam.active ? 0.9 : 0.45,
        );
    }
    for (let i = count; i < objects.length; i++) objects[i].visible = false;
    group.visible = count > 0;
  }
  return { draw, diagnostics: () => ({ segments: count, capacity: objects.length }) };
}
